import React from "react";
import PageTitle from "../../shared/PageTitle";
import { useState, useEffect } from "react";
import { BlankString, BTN_SMALL_LOADER, MenuId, Roles } from "../../Constants";
import Loader from "../../shared/Loader";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ActionTypes } from "../../redux/ActionTypes";
import { useDispatch } from "react-redux";
import { loginFormLabelsText } from "../../Constants";
import ILoginForm from "./models/interfaces/ILoginForm";
import { SetStorageItem, GetStorageItem } from "../../helpers/Functions";
import { AuthenticationConstans } from "../../Constants";
import IUserInfo from "./models/interfaces/IUserInfo";
import { HTTPStatusCodes } from "../../Constants";
import { PostData } from "../../helpers/Fetch";
import jwt_decode from "jwt-decode";
import { GetUserRoles } from "../../helpers/Functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

declare global {
  interface Window {
    SetMenuArrowIcon: () => void;
  }
};

export default function Login() {
  const userIdentity = GetStorageItem(AuthenticationConstans.Identity);
  const defaultLoginForm: ILoginForm = { username: BlankString, password: BlankString, showSpinner: false, userNameError: BlankString, passwordError: BlankString, responseMessage: BlankString, loginSuccess: false };
  const [responseData, setResponseData] = useState<any | undefined>(undefined);
  const [loginFormDetails, setLoginFormDetails] = useState<ILoginForm>(defaultLoginForm);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const AuthenticateHandler = (event: any) => {
    event.preventDefault();
    if (state !== null) {
      state.expiredToken = false;
      state.successMessage = undefined;
    }
    if (!loginFormDetails.username && !loginFormDetails.password) {
      setLoginFormDetails({
        ...loginFormDetails,
        userNameError: loginFormLabelsText.usernameInputError,
        passwordError: loginFormLabelsText.passwordInputError
      });
      return;
    }
    if (!loginFormDetails.username) {
      setLoginFormDetails({
        ...loginFormDetails,
        userNameError: loginFormLabelsText.usernameInputError
      });
      return;
    }
    if (!loginFormDetails.password) {
      setLoginFormDetails({
        ...loginFormDetails,
        passwordError: loginFormLabelsText.passwordInputError
      });
      return;
    }
    setLoginFormDetails({
      ...loginFormDetails,
      showSpinner: true,
      responseMessage: BlankString
    });

    const requestData = { email: loginFormDetails.username, password: loginFormDetails.password };
    PostData(requestData, "Security/CreateToken").then(response => {
      if (!response.error) {
        if (response.statusCode === HTTPStatusCodes.OK) {
          if (response.data.statuCode !== HTTPStatusCodes.OK) {
            setLoginFormDetails({
              ...loginFormDetails,
              showSpinner: false,
              responseMessage: response.data.errorMessage
            });
          }
          if (response.data.statusCode == HTTPStatusCodes.OK) {
            setLoginFormDetails({
              ...loginFormDetails,
              showSpinner: false,
              responseMessage: BlankString,
              loginSuccess: true
            });
            setResponseData(response.data);
          }
        } else {
          setLoginFormDetails({
            ...loginFormDetails,
            showSpinner: false,
            responseMessage: response.errorMessage
          });
        };
      } else {
        setLoginFormDetails({
          ...loginFormDetails,
          showSpinner: false,
          responseMessage: response.errorMessage
        });
      }
    });
  };

  const onChangeHandler = (event: any) => {
    if (event.target.name === "username") {
      setLoginFormDetails({
        ...loginFormDetails,
        username: event.target.value,
        userNameError: BlankString,
        responseMessage: BlankString
      });
    }
    if (event.target.name === "password") {
      setLoginFormDetails({
        ...loginFormDetails,
        password: event.target.value,
        passwordError: BlankString,
        responseMessage: BlankString
      });
    }
  };

  useEffect(() => {
    dispatch({ type: ActionTypes.SET_ACTIVE_LINK, payload: MenuId.LOGIN });
    window.history.replaceState({}, document.title);
    if (userIdentity !== null) navigate("/");
    let isMounted = true;
    if (isMounted && loginFormDetails.loginSuccess && (responseData !== undefined)) {
      const token: string = responseData.jwt.token;
      const decoded_token: any = jwt_decode(token);
      const userInfo: IUserInfo = { token, name: decoded_token.name, menu: false };
      const identity = JSON.stringify(userInfo);
      SetStorageItem(AuthenticationConstans.Identity, identity);
      dispatch({ type: ActionTypes.SET_IDENTITY_NAME, payload: identity });
      const isAdmin = GetUserRoles().includes(Roles.ADMIN);
      const landingPage = isAdmin ? "/Brokers/SendRegistration" : "/"
      navigate(landingPage);
    }
    return () => { isMounted = false };
  }, [loginFormDetails, userIdentity, responseData]);

  return (
    <>
      <PageTitle title="Authenticate" />
      <div className="container gp-container">
        <form noValidate>
          <div className="row">
            <div className="col-md-4">
              <div className={loginFormDetails.responseMessage === BlankString ? "display-none" : "alert alert-danger"}>{loginFormDetails.responseMessage}</div>
              {
                (state !== null && state.expiredToken === true) ?
                  <div className="alert alert-info" role="alert">
                    Your session is expired, login again to continue
                  </div>
                  :
                  null
              }
              {
                (state !== null && state.successMessage) ?
                  <div className="alert alert-success" role="alert">
                    {state.successMessage}
                  </div>
                  :
                  null
              }
              <p className="input-info">
                <label className={loginFormDetails.userNameError !== BlankString ? "display-none" : BlankString}>{loginFormLabelsText.username}</label>
                <label className={loginFormDetails.userNameError === BlankString ? "display-none" : "error"}>{loginFormLabelsText.usernameInputError}</label>
                <input
                  type="text"
                  name="username"
                  placeholder={loginFormLabelsText.username}
                  onChange={onChangeHandler}
                  value={loginFormDetails.username} autoComplete="false"
                  className={loginFormDetails.userNameError !== BlankString ? "input-validation-error" : "error"} />
              </p>
              <p className="input-info">
                <label className={loginFormDetails.passwordError !== BlankString ? "display-none" : BlankString}>{loginFormLabelsText.password}</label>
                <label className={loginFormDetails.passwordError === BlankString ? "display-none" : "error"}>{loginFormLabelsText.passwordInputError}</label>
                <input
                  type="password"
                  name="password"
                  placeholder={loginFormLabelsText.password}
                  onChange={onChangeHandler} autoComplete="false"
                  className={loginFormDetails.passwordError !== BlankString ? "input-validation-error" : "error"} />
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <button type="submit" className="btn-sm btn-small" onClick={AuthenticateHandler} disabled={loginFormDetails.showSpinner}>
                <FontAwesomeIcon icon={solid("lock")} /> Secure Login
              </button>
              <Loader size={BTN_SMALL_LOADER} loading={loginFormDetails.showSpinner} />
            </div>
          </div>
          <div className="row top-margin-5">
            <div className="col-md-4">
              <Link to="/ForgotPassword" style={{ color: "#0000ff", fontSize: 15 }}>Forgot Password?</Link>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};